exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-18c1ca90] .md-menu-content.md-select-menu {\n  width: 150px;\n}\n.modal-body[data-v-18c1ca90] {\n  padding-top: 12px;\n}\n.modal-container[data-v-18c1ca90] {\n  max-width: 600px;\n}\n.title[data-v-18c1ca90] {\n  margin-bottom: 12px;\n  text-align: center;\n}\n\n/*.form-container {\r\n    height: 500px;\r\n}*/\n", ""]);

// exports
